import { getXgenProducts } from './Product.js'

export const money = (amount) => {
  return `${window.currencySymbol}${(parseFloat(amount) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 })}`
}
export const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,:\s@\"]+(\.[^<>()[\]\\.,:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}
export const isInViewport = (el) => {
  const rect = el.getBoundingClientRect()
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  )
}

export const makeid = (length) => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  let counter = 0
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }
  return result
}

export const videoHtml = (sources, id='', classes='', controls=true, poster='', captionEnglish='') => {
  let videoHtml = `<video
    id="video-${id}"
    class="video-js ${classes} ${controls ? '' : 'no-video-controls'}"`
  videoHtml += ` ${controls ? 'controls' : ''} `
  videoHtml += `
    muted
    autoplay
    playsinline
    loop
    preload="metadata"
    data-video
    poster="${poster}&width=1600"
    data-setup='{}'>`
  sources.forEach((source) => videoHtml += `<source src="${source.url}" type="${source.mime_type}"></source>`)
  videoHtml += `
        ${!!captionEnglish ? '<track label="English" kind="subtitles" srclang="en" src="' + captionEnglish + '" default />' : ''}
        <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that supports HTML5 video
      </p>
    </video>`

  return videoHtml
}

export const videoControl = (video) => {
  const button = !!video.id ? document.querySelector(`[data-video-element="${video.id}"]`) : null
  
  button?.addEventListener('click', () => {
    button.classList.toggle('video-paused')
    if(button.classList.contains('video-paused'))
      video.pause()
    else
      video.play()
  })
}

export const adjustADA = () => {
  setTimeout(() => {
    const swiperButtons = document.querySelectorAll('.swiper-button[aria-disabled]')
    swiperButtons.forEach(button => button.removeAttribute('aria-disabled'))
  }, 1500)
}

export const updateSearchRecommend = (parent=document) => {
  const searchRecommendSwiper = parent.querySelector(`[data-search-rec-swiper]`)
  const xgenId = searchRecommendSwiper?.getAttribute('data-xgen-id')
  const excludeSaleAttr = searchRecommendSwiper?.getAttribute('data-exclude-sale')
  if(xgenId && searchRecommendSwiper) {
    const excludeSale = excludeSaleAttr == true || excludeSaleAttr == 'true'
    if(typeof getXgenPredictions != 'undefined') {
      getXgenPredictions(xgenId).then((results) => {
        const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
        getXgenProducts((results) => {
          console.log(results)
          const filteredResults = excludeSale ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale')) : results
          const swiperWrapper = searchRecommendSwiper.querySelector('.swiper-wrapper')
          filteredResults.forEach(result => {
            result.related = true
            result.context = 'search'
            swiperWrapper.innerHTML +=  `
              <div class="swiper-slide">
                <div class="h-full" product-tile props='${JSON.stringify(result).replaceAll("'", "’")}'></div>
              </div>
            `
          })
          setTimeout(() => {
            window.setupProductTiles(searchRecommendSwiper.querySelectorAll('[product-tile]:empty'))  
            if(searchRecommendSwiper.swiper) searchRecommendSwiper.swiper.destroy(true, true)
            function initSwiper() {
              if(window.innerWidth >= 1024) {
                if(!searchRecommendSwiper.swiper) {
                  new Swiper(searchRecommendSwiper, {
                    speed: 500,
                    spaceBetween: 12,
                    slidesPerView: 2,
                    breakpoints: {
                      300: {
                        slidesPerView: 2.2,
                        spaceBetween: 8,
                      },
                      375: {
                        slidesPerView: 2.2,
                        spaceBetween: 12,
                      },
                      768: {
                        slidesPerView: 3.2,
                        spaceBetween: 12,
                      },
                      1024: {
                        slidesPerView: 6,
                        spaceBetween: 12,
                      },
                      1440: {
                        slidesPerView: 8,
                        spaceBetween: 12,
                      },
                    },
                    navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    }
                  })
                }
              } else {
                if(searchRecommendSwiper.swiper) searchRecommendSwiper.swiper.destroy(true, true)
              }
            }
            initSwiper()

            window.addEventListener('resize', () => {
              initSwiper()
            })
          }, 300)
        }, skus)
      })
    }
  }
}
window.updateSearchRecommend = updateSearchRecommend

export const showAlertMessage = (message, duration=3000) => {
  const alertMessage = document.querySelector('[data-alert-message]')
  if(alertMessage) {
    // Clear any existing content first
    alertMessage.innerHTML = ''
    
    // Show the element and make it visible to screen readers
    alertMessage.classList.remove('hidden')
    alertMessage.setAttribute('aria-hidden', 'false')
    
    // Add the message content - this will trigger the ARIA live announcement
    alertMessage.innerHTML = message
    
    // Hide after duration
    setTimeout(() => {
      alertMessage.setAttribute('aria-hidden', 'true')
      alertMessage.classList.add('hidden')
      // Clear content after hiding to prepare for next message
      setTimeout(() => {
        alertMessage.innerHTML = ''
      }, 100)
    }, duration)
  }
}